export default __webpack_public_path__ + "static/media/shift.d2f07cff.svg";